var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CapitalMgt"},[_c('keep-alive',{attrs:{"include":_vm.includeList}},[_c('router-view',{attrs:{"hostroletype":_vm.hostroletype,"hostroleinnerid":_vm.hostroleinnerid}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }